import axios from 'axios';
import { GET, aicaBaseUrl } from '../../utils/axios-interceptor';
import { AicaHistoryResponse } from '../../types/ownerHistory';
import { HISTORY_DRAWER_API_PATHS } from './constants';

export const fetchHistory = (payload: { referenceId: string; key: string }) => {
    return axios<AicaHistoryResponse>({
        url: HISTORY_DRAWER_API_PATHS.GET_HISTORY,
        method: GET,
        params: payload,
        baseURL: aicaBaseUrl,
    });
};
